import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/api/client";

export default function Search() {
  const [sp, setSp] = useSearchParams();
  const [q, setQ] = useState(sp.get("q") || "");
  const [data, setData] = useState({ groups: {} });
  useEffect(() => { if (q) api.get("/v1/search/", { params: { q } }).then((r) => setData(r.data)); }, [q]);

  const ROUTE = { clients: "/clients", contacts: "/contacts", projects: "/projects" };

  return (
    <div className="p-8 space-y-6" data-testid="search-page">
      <h1 className="font-editorial text-4xl tracking-tight">Search</h1>
      <input
        data-testid="search-input"
        value={q} onChange={(e) => { setQ(e.target.value); setSp({ q: e.target.value }); }}
        placeholder="Search all records…"
        className="w-full rounded-md border border-[#E7E5E4] bg-[#FFFFFF] px-3 py-2 focus:border-[#FFC817] outline-none"
      />
      {Object.entries(data.groups).map(([entity, items]) => (
        <section key={entity} className="rounded-lg border border-[#E7E5E4] bg-[#FFFFFF]">
          <header className="border-b border-[#E7E5E4] px-4 py-3 text-xs uppercase tracking-wider text-[#A8A29E]">{entity} ({items.length})</header>
          <div className="divide-y divide-[#E7E5E4]">
            {items.map((r) => (
              <Link key={r.id} to={`${ROUTE[entity] || "/"}/${r.id}`} className="block px-4 py-3 hover:bg-[#F5F5F4]">
                <div className="text-sm text-[#1C1C1E]">{r.name || r.title || r.id}</div>
                <div className="text-[10px] text-[#A8A29E] font-mono">{r.id}</div>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
